/*
  Instalments bar → app popups.

  The price block draws the instalments bar in the theme's own design. The Afterpay and Zip app
  blocks are still on the page (hidden by .pi-app-block--bnpl) because they own the popups. A logo
  click in the bar is forwarded to the matching app widget, so the shopper gets the app's own
  popup with the app's own wording and limits.

  Delegated from document: product-info.js replaces the bar's innerHTML on every variant change,
  so listeners bound to the buttons themselves would be lost after the first swap.

  - Afterpay renders <square-placement>/<afterpay-placement> with an open shadow root; its modal
    link sits inside it. window.Afterpay.launchModal() is the fallback if that markup changes.
  - Zip renders <quadpay-widget>, whose popup trigger lives in its shadow root (see openZip).
  Both apps mount the popup on document.body, so it shows even though the widget is hidden.
*/
(function () {
  if (window.piInstalmentsBound) return;
  window.piInstalmentsBound = true;

  function findAppBlock(trigger, provider) {
    var scope = trigger.closest('product-info') || document;
    return scope.querySelector('[data-bnpl-app="' + provider + '"]') ||
      document.querySelector('[data-bnpl-app="' + provider + '"]');
  }

  function openAfterpay(block) {
    var placement = block && block.querySelector('square-placement, afterpay-placement');
    var root = placement && placement.shadowRoot;
    var link = root && root.querySelector('a, button, [role="button"]');

    if (link) {
      link.click();
      return true;
    }

    if (window.Afterpay && typeof window.Afterpay.launchModal === 'function') {
      window.Afterpay.launchModal();
      return true;
    }

    return false;
  }

  // The Zip app renders <quadpay-widget id="zip-product-widget" data-zm-widget="popup">, a custom
  // element with an open shadow root. Its popup listeners sit on the [data-modal] / info icon nodes
  // INSIDE that shadow root, so a click on the host element itself never reaches them. The element
  // also exposes openModal(), which is what those listeners call — used first, with a click on the
  // shadow trigger as the fallback. dispatchEvent, not .click(): the trigger can be an <svg>.
  function openZip(block) {
    var widget = block && block.querySelector('quadpay-widget, quadpay-widget-v3, zip-widget, [data-zm-widget]');
    if (!widget) return false;

    if (typeof widget.openModal === 'function') {
      widget.openModal();
      return true;
    }

    var root = widget.shadowRoot;
    var trigger = root && root.querySelector('[data-modal], quadpay-info-icon, button, [role="button"], a');

    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window }));
      return true;
    }

    return false;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-bnpl-open]');
    if (!trigger) return;

    var provider = trigger.getAttribute('data-bnpl-open');
    var block = findAppBlock(trigger, provider);
    var opened = provider === 'afterpay' ? openAfterpay(block) : openZip(block);

    if (!opened) {
      console.warn('[pi-instalments] ' + provider + ' widget not ready — popup not opened.');
    }
  });
})();
